import "./bookings-table-grids.less";

import BookingPeriodTableModule from "./booking-periods-table/module";

import bookingHero from "./booking-hero";
import dibsForm from "./dibs-form";
import dibsLegacy from "./dibs-legacy";

//import onPayForm from "./onPay-form";
import paymentCards from "./payment-cards";
import bookingWizard from "./booking-wizard";
import bookingInfoboxMobile from "./booking-infobox-mobile";
import bookingInfobox from "./booking-infobox";

import bookingCompletedInfobox from "./booking-completed-infobox";

import orderSummary from "./order-summary";
import orderDetails from "./order-details";
import bookingDetails from "./order-details/booking-details";
import bookingError from "./booking-error";

import bookingCompletedAddons from "./order-details/booking-details/booking-completed-addons";

const modul = angular
    .module("CheckoutComponents", [BookingPeriodTableModule])
    .directive("bookingHero", bookingHero)
    .directive("dibsLegacy", dibsLegacy)
    //.directive("onPayForm", onPayForm)
    .directive("paymentCards", paymentCards)
    .directive("bookingWizard", bookingWizard)
    .directive("bookingInfoboxMobile", bookingInfoboxMobile)
    .directive("bookingInfobox", bookingInfobox)
    .directive("orderDetails", orderDetails)
    .directive("orderSummary", orderSummary)
    .directive("bookingCompletedAddons", bookingCompletedAddons)
    .directive("bookingCompletedInfobox", bookingCompletedInfobox)
    .directive("bookingError", bookingError)
    .directive("bookingDetails", bookingDetails);

export default modul.name;
